<template>
      <div no-body class="lku-coa"> 
      <b-row>
        <b-col lg="7">
          <b-form-group label-cols=3 label="Filter Account">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.kodeacc" @keyup.13.native="refresh()" placeholder="Code"></b-form-input></b-col>
                <b-col class="pl-1" cols="8"><b-form-input v-model="tblData.namaacc" @keyup.13.native="refresh()" placeholder="Name"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="5">
          <b-form-group label-cols=2 label="Year Of">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.tahun" placeholder="Year" disabled></b-form-input></b-col>
                <b-col class="pl-1" cols="7">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  </b-row>                  
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCoa" style="font-size:smaller;" 
          responsive small striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(namaacc)="data">
            <!-- <span v-if="(data.item.judul=='Y')" v-html="data.item.accname" style="font-weight:bold;"></span>
            <span v-else v-html="data.item.accname"></span> -->
                <span v-if="(data.item.judul=='Y')"  style="font-weight:bold;" :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
                <span v-else  :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-coa {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import coa from "../../apis/consolidacoa";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "tahun",
            thStyle: "width:100px",
            label: "Year"
          },
          {
            key: "kodeacc",
            label: "Account Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Account Name",
          },
          {
            key: "typeacc",
            thStyle: "width:100px",
            label: "Type"
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'kodeacc',
        sortDesc: false,
        tahun: ''
      }
    };
  },
  computed: {
    filterNamaAcc() {
      return this.tblData.namaacc;
    },
  },
  watch: {
    filterNamaAcc: function(namaacc) {
      setTimeout(() => {
        if (namaacc == this.tblData.namaacc) this.refresh();
      }, 500);
    },
    tahun: function(newVal) {
      if (newVal) {
        this.tblData.tahun = newVal;
        this.refresh();
      }
    }
  },
  props: ["tahun", "allowHeader"],
  created: async function() {
      const activeTahun = this.tahun || (this.$store.state.user.tglaktifconsol || this.$store.state.user.tglaktif || '').substring(0, 4);
      this.tblData.tahun = activeTahun;
      if (!this.tahun) {
        this.$emit('update:tahun', activeTahun);
      }
      this.$emit('update:allowHeader', false);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.tahun = this.tahun || this.tblData.tahun;
      return await coa.list(this.tblData);      
    },
    selectItem(item,index) {
      if (this.allowHeader == true){
          this.$emit("click", item);
      } else {
        if (item.judul!=='Y'){
          this.$emit("click", item);
        } else {
          toastr.warn('Account punya anak tidak boleh dipilih!');
        }
      }
    },
    clearFilter() {
        this.tblData={kodeaccc:'', namaacc: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCoa.refresh();
       }
    },    
    refresh() {
      this.$refs.tblCoa.refresh();
    }
  }
};
</script>
